import { render, staticRenderFns } from "./pcRegister.vue?vue&type=template&id=1c04bd4e&scoped=true"
import script from "./pcRegister.vue?vue&type=script&lang=js"
export * from "./pcRegister.vue?vue&type=script&lang=js"
import style0 from "./pcRegister.vue?vue&type=style&index=0&id=1c04bd4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04bd4e",
  null
  
)

export default component.exports